import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    reviews: [],
    currentReview: null,
    isLoading: false,
  }),
  getters: {
    reviews: (s) => s.reviews,
    currentReview: (s) => s.currentReview,
    isLoading: (s) => s.isLoading,
  },
  mutations: {
    SET_REVIEWS(state, payload) { state.reviews = payload; },
    SET_CURRENT_REVIEW(state, payload) { state.currentReview = payload; },
    SET_LOADING(state, v) { state.isLoading = v; },
  },
  actions: {
    async fetchReviewerReviews({ commit }) {
      const token = localStorage.getItem("token");

      const { data } = await axios.get(
        "https://apidash.smartpress.kz/api/reviews",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      commit("SET_REVIEWS", data.items || []);
    },

    async fetchReviewDetails({ commit }, reviewId) {
      const token = localStorage.getItem("token");
      const { data } = await axios.get(`https://apidash.smartpress.kz/api/reviews/${reviewId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      commit("SET_CURRENT_REVIEW", data.review);
    },
  },
};
